import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Search, Plus, Sparkles } from 'lucide-react';

export default function MobileBottomNav({ onSearchOpen }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleHome = () => {
    navigate('/');
    // Smooth scroll to Vandaag section if we are already on Dashboard
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSearch = () => {
    if (onSearchOpen) onSearchOpen(true);
  };

  const handleAdd = () => {
    window.dispatchEvent(new Event('open-quick-add'));
  };

  const handleAssistant = () => {
    window.dispatchEvent(new Event('open-ai-assist'));
  };

  const isHome = location.pathname === '/';

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 h-[56px] bg-white dark:bg-[#111827] border-t border-slate-200 dark:border-[#30363D] z-[40] flex items-center justify-around px-2 pb-safe shadow-[0_-4px_10px_rgba(0,0,0,0.05)] dark:shadow-[0_-4px_10px_rgba(0,0,0,0.2)]" data-testid="mobile-bottom-nav">
      <button
        onClick={handleHome}
        className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isHome ? 'text-[#2E75B6]' : 'text-slate-400 dark:text-[#8B949E] hover:text-slate-600 dark:hover:text-[#C9D1D9]'}`}
      >
        <LayoutDashboard className={`w-5 h-5 ${isHome ? 'fill-[#2E75B6]/20' : ''}`} />
        <span className="text-[10px] font-medium">Vandaag</span>
      </button>

      <button
        onClick={handleSearch}
        className="flex flex-col items-center justify-center w-full h-full space-y-1 text-slate-400 dark:text-[#8B949E] hover:text-slate-600 dark:hover:text-[#C9D1D9]"
      >
        <Search className="w-5 h-5" />
        <span className="text-[10px] font-medium">Zoeken</span>
      </button>

      <button
        onClick={handleAdd}
        className="flex flex-col items-center justify-center w-full h-full space-y-1 text-slate-400 dark:text-[#8B949E] hover:text-slate-600 dark:hover:text-[#C9D1D9]"
      >
        <Plus className="w-5 h-5" />
        <span className="text-[10px] font-medium">Toevoegen</span>
      </button>

      <button
        onClick={handleAssistant}
        className="flex flex-col items-center justify-center w-full h-full space-y-1 text-slate-400 dark:text-[#8B949E] hover:text-slate-600 dark:hover:text-[#C9D1D9]"
      >
        <Sparkles className="w-5 h-5" />
        <span className="text-[10px] font-medium">Assistent</span>
      </button>
    </div>
  );
}
